// HTMX — bundled from node_modules by esbuild
import htmx from 'htmx.org';

// Expose globally (templates use hx-* attributes, htmx needs to be on window)
window.htmx = htmx;

// HTMX config
htmx.config.historyCacheSize = 0;
htmx.config.refreshOnHistoryMiss = true;
// The app shell scrolls the window, with a sticky top bar. htmx's default of
// scrolling a boosted swap target to the viewport top would tuck #page-content
// under that bar; htmx-nav.js scrolls to the real top after each page swap.
htmx.config.scrollIntoViewOnBoost = false;

// Shared cookie helpers (_cc.getCookie / _cc.setCookie) — must load before any module that writes one
import './cookies.js';

// CSRF token injection for HTMX requests (must load before any HTMX components)
import './csrf.js';
import './copy-from.js';

// SeeMe components (vendored from ~/seeme via /sync-seeme)
import '../seeme/tables.js';
import '../seeme/sidenav.js';
import '../seeme/auto-resize.js';
import '../seeme/file-attach.js';
import '../seeme/show-when.js';
import '../seeme/copy-link.js';
import '../seeme/dropdowns.js';
// confirm-delete.js registers after dropdowns.js (same order as seeme.js): the
// first Delete tap only arms, and dropdowns.js reads data-confirm-armed to tell
// that tap from the confirming one before it restores a portaled menu.
import '../seeme/confirm-delete.js';
import '../seeme/tabs.js';
import '../seeme/tabs-collapse.js';
import '../seeme/breadcrumb-collapse.js';
import '../seeme/combobox.js';
import '../seeme/list-group.js';
import '../seeme/inline-edit.js';

// Combobox navigation mode — select navigates to option's href via HTMX boost
document.addEventListener('combobox:select', function (e) {
    const combobox = e.target.closest('[data-combobox-navigate]');
    if (!combobox || !e.detail.option) return;
    const href = e.detail.option.getAttribute('href');
    if (!href) return;
    // Find the nearest hx-boost container and use its target/select/swap
    const boostEl = combobox.closest('[hx-boost]');
    if (boostEl && window.htmx) {
        htmx.ajax('GET', href, {
            target: boostEl.getAttribute('hx-target') || 'body',
            select: boostEl.getAttribute('hx-select') || undefined,
            swap: boostEl.getAttribute('hx-swap') || 'innerHTML',
        });
        history.pushState({}, '', href);
    } else {
        window.location.href = href;
    }
});

import '../seeme/clamp.js';
import '../seeme/sheet-nav.js';
import '../seeme/modals.js';
import '../seeme/lightbox.js';
import '../seeme/tooltip.js';

// Subnav collapse compat (data-toggle="collapse" without Bootstrap JS)
import './subnav-collapse.js';

// Post-swap navigation handler (active nav, jQuery reinit, loading indicator)
import './htmx-nav.js';
import './shell.js';

// Sheet slide-over panel (right side panel / bottom sheet)
import './sheets.js';

// URL history for lazy SeeMe modals/sheets
import './modal-history.js';

// Ownership Review queue → responsive review overlay (registers an rfmodal:resolve handler)
import './ownership-review.js';

// RF Dropdown System (data-rf-dropdown — prefixed to avoid Bootstrap conflicts on legacy pages)
import './rf-dropdowns.js';

// Typeahead search-as-you-type (shared SeeMe component)
import '../seeme/typeahead.js';

// Google Places address autocomplete (shared SeeMe component)
import '../seeme/places-typeahead.js';

// Multi-select tag input (chips + searchable dropdown)
import '../seeme/tag-input.js';

// Auto-loading spinners for HTMX requests (icon-swap, btn--loading, overlay)
import '../seeme/loading.js';

// Toast notifications (SeeMe toasts — exposes SeeMe.toast / showToast)
import '../seeme/toasts.js';
SeeMe.toast.position = 'bottom-right';

// Declarative HTMX after-request actions (data-success-toast, HX-Trigger bridge, etc.)
import './htmx-actions.js';

// Topbar search results dropdown (show/hide on HTMX swap, click-outside dismiss)
import './topbar-search.js';

// Styleguide theme toggle (dark/light switcher, only activates on .sg-page)
import '../seeme/styleguide-theme-toggle.js';

// Combobox inline-create (reveal mini-form on "Add new...", inject + select created option)
import './combobox-inline-create.js';

// Combobox "Add" that keeps the typed text as the value (seller listing email/phone)
import './combobox-add-value.js';

// Offer and seller-listing field visibility, clearing, and native validation.
import './offer-listing-form-conditions.js';

// HOA lookup Confirm fills the seller listing's HOA toggle, picker, and dues
import './listing-hoa-lookup.js';

// Doc page: loads the doc editor bundle and mounts it on [data-doc-editor]
import './doc-loader.js';

// PM CRM create sheet utilities (quick date picker, inline affiliate create)
import './pm-crm-create.js';

// PM CRM utilities (log filters, etc.)
import './pm-crm-utils.js';

// PM CRM file uploads (drag-and-drop + click-to-browse)
import './pm-crm-files.js';

// Inspection photo uploads (drag-and-drop + click-to-browse)
import './inspection-photos.js';

// Acqs property image uploader (drag-drop multi-file queue with per-row room + caption)
import './acqs-image-uploader.js';

// Property videos: upload with progress, processing poll cards, lightbox player (all four media surfaces)
import './property-videos.js';

// Rental gallery drag ordering (server-rendered rental/parent capability only)
import './rental-photos.js';

// Acqs gallery bulk photo delete (fullscreen multi-select "delete mode")
import './acqs-image-delete-mode.js';

// Acqs property detail interactive map
import './acqs-property-map.js';

// Acqs file uploader (drag-drop multi-file queue with per-row file_type + notes)
import './acqs-file-uploader.js';

// Fetch-and-save downloads with a spinner (`[data-download]`, `fetchDownload`)
import './file-download.js';

// Acqs Scope of Work — bank-ready PDF download (through `fetchDownload`)
import './acqs-sow-pdf.js';

// Acqs New Deal create sheet — partner picker controller
import './acqs-deal-create.js';

// Acqs assignment sheets — live "Total price to buyer" (contract price + fee)
import './assignment-sheet.js';

// PM CRM proposal revenue auto-calc (units × rent × fee%)
import './proposal-revenue.js';

// PM CRM email reply card (CC toggle, file picker)
import './email-reply.js';

// PM CRM form helpers (inline create toggles, CC suggestions)
import './pm-crm-forms.js';

// PM CRM WebSocket (real-time list row refresh)
import './pm-crm-ws.js';

// Acqs WebSocket (real-time property/owner list refresh)
import './acqs-ws.js';

// Acqs lead SMS composer — attach images (MMS)

// Acqs email and SMS composers — the Templates picker fills the draft (Suggest reply and Improve use email-ai.js)
import './acqs-composer-fill.js';

// The Bot chip menu's Show decisions switch for a lead's SMS timelines
import './acqs-bot-decisions.js';

// Rentals list glue (row_qs for the row panels, previous-action preset chips)
import './rentals-list.js';

// Rentals list WebSocket (real-time row refresh / removal)
import './rentals-ws.js';

// Rental page SMS WebSocket (General conversation + rail badge live on inbound texts)
import './rental-sms-ws.js';

// Top-bar Messages envelope counts and the General text toast (frames relayed by rental-sms-ws.js)
import './sms-envelope.js';

// Marketing WebSocket (real-time blast row refresh)
import './marketing-ws.js';

// Work: committed task/plan changes refresh visible regions.
import './work-ws.js';

// Work: compact next-action and due-date picker controls.
import './work-schedule.js';

// PM CRM email AI (Accept/Cancel suggestion card)
import './email-ai.js';

// KB knowledge base — AI enhance suggestion (Accept/Cancel + chip tone selector)
import './kb-ai.js';

// Markdown preview toggle (eye icon — edit ↔ rendered preview)
import './markdown-preview.js';

// Collections Review — suggest edit AI (Accept/Cancel + save to KB)
import './review-suggest-edit.js';

// Agent WebSocket — unified bot WS for live updates (collections, leasing, etc.)
import './agent-ws.js';

// Relative timestamps ("5m ago", "2h ago") for recent log entries
import './relative-time.js';
import './browser-local-datetime.js';
import './appointment-time-fields.js';
import './appointment-location-fields.js';

// Agent Chat — deal AI transport layer (WebSocket + SeeMe AiChat shell)
import './agent-chat.js';

// Buyer offer intake — durable draft and sealed-packet workspace.
import './offer-intake.js';

// AI Chat widget (SeeMe shared component — FAB + floating chat panel)
import '../seeme/ai-chat.js';

// Keyboard shortcuts & spotlight search (SeeMe shared modules)
import '../seeme/shortcuts.js';
import '../seeme/spotlight.js';
import './keyboard-shortcuts.js';

// Input guards & clipboard fixes (lifted from legacy _scripts.html)
import './input-guards.js';

// Dialer — in-browser calling via Twilio Voice SDK (persistent bottom-left dock)
import './dialer.js';

// Call recording — slim inline audio player in the acqs activity feed
import './call-recording.js';

// Campaign audience DNF filter-group builder (per-group commit, drag-reorder)
import './filter-group-builder.js';

// Action plan task lists — drag-to-reorder within a sibling group
import './sortable-work.js';

// Filter bars that swap only their results — keep the chip counts honest
import './filter-chips-live.js';

// Master Tasks table — subtask count chip expands its rows in place
import './work-subtasks.js';

// Master Tasks table — re-bind SeeMe table behaviour after a swap
import './work-task-table.js';

// Master Tasks list — select a related record before loading plan filters.
import './work-plan-filter.js';
import './work-date-filters.js';
import './work-related-picker.js';

// PropertyLeads refund question on the close, Dead and Discard sheets
import './refund-question.js';
// PropertyLeads refund claim Build proof: the Key proof picker
import './refund-key-proof.js';
